export const MENU_TYPE = {
  FILE: "FILE",
  HELP: "HELP",
};

export const MENU = {
  SAVE_PROJECT: "SAVE_PROJECT",
  SAVE_TO_FILE: "SAVE_TO_FILE",
  OPEN_FROM_FILE: "OPEN_FROM_FILE",
  IMPORT_GLB: "IMPORT_GLB",
  EXPORT_GLB: "EXPORT_GLB",
  SAVE_AS_ASSET: "SAVE_AS_ASSET",
  WIKI: "WIKI",
  DISCORD: "DISCORD",
};

const fileMenu = [
  {
    name: "Save",
    type: MENU.SAVE_PROJECT,
  },
  {
    name: "Save to File",
    type: MENU.SAVE_TO_FILE,
  },
  {
    name: "Open from File",
    type: MENU.OPEN_FROM_FILE,
  },
  {
    name: "Import GLB",
    type: MENU.IMPORT_GLB,
  },
  {
    name: "Export GLB",
    type: MENU.EXPORT_GLB,
  },
  {
    name: "Save as Asset",
    type: MENU.SAVE_AS_ASSET,
  },
];

const helpMenu = [
  {
    name: "Wiki",
    description: "Learn more about the studio!",
    type: MENU.WIKI,
  },
  {
    name: "Discord",
    description: "If you want to ask a question?",
    type: MENU.DISCORD,
  },
];

export const menus = {
  [MENU_TYPE.FILE]: fileMenu,
  [MENU_TYPE.HELP]: helpMenu,
};
